import { AnimatePresence, motion } from 'motion/react';
import { useTranslation } from 'react-i18next';
import { CloseIcon } from '@/icons';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    onOpenNow: () => void;
};

export function LuckyDrawBannerPopup({ isOpen, onClose, onOpenNow }: Props) {
    const { t } = useTranslation();

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className="fixed inset-0 z-50 "
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={onClose}
                >
                    <motion.div
                        className="relative h-full w-full"
                        initial={{ opacity: 0, scale: 1.05 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 1.05 }}
                        transition={{ duration: 0.25 }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <img
                            src="/images/popup-lucky-reward.png"
                            alt={t('Lucky Draw for iPhone 18 Pro')}
                            className="block h-full w-full object-cover"
                        />
                        <button
                            onClick={onClose}
                            className="cursor-pointer absolute right-2 top-2 flex size-10 items-center justify-center text-white"
                            aria-label={t('Close')}
                        >
                            <CloseIcon className="size-6" />
                        </button>
                        <button
                            onClick={onOpenNow}
                            className="cursor-pointer absolute bottom-[17%] left-1/2 h-[6.5%] w-[42%] -translate-x-1/2 rounded-full opacity-0"
                            aria-label={t('Open Now')}
                        />
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
